import React, { LegacyRef, useEffect, useState } from 'react';
import cn from 'classnames';
import I18n from 'hooks/useI18n';

import IconButton from 'components/common/buttons/IconButton';
import ReconnectingLabel from '../ReconnectingLabel';
import { createMarkup } from 'functions/webUtils';
import ProfileOptionDropDown from '../memberProfile/ProfileOptionDropDown';
import { icArrDownEvt, icArrow, icBackHeader, icBackHeaderWhite } from 'redhotpie-shared-lib/themes/ImagesSVG';

import { REF_ID } from 'redhotpie-shared-lib/constants/constants';

import './styles.scss';
import Div from 'components/common/Div';
import { useDispatch } from 'redhotpie-shared-lib/hooks/useRedux';
import Img from 'components/common/Img';
import { useTheme } from 'hooks/useTheme';

interface HeaderMemberProps {
  isFixedTop?: boolean;
  isHeaderMain?: boolean;
  isLowercase?: boolean;
  disableIcLeft?: boolean;
  txtLeft?: string | React.ReactNode;
  isChangeTxtHeader?: boolean;
  icRight?: string;
  customStyles?: object;
  txtRight?: string;
  onClickRightIcon?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isError?: boolean;
  isMobile?: boolean;
  classContainer?: string;
  textHeaderClassName?: string;
  isHeaderTextNone?: boolean;
  customClassHeader?: string;
  renderIconLeft?: React.ReactNode;
  registerRefWithKeyAuto?: (ref: HTMLDivElement, key: string) => void;
  icLeft?: string;
  onClickLeftIcon?: () => void;
  renderHeader?: React.ReactNode;
  textHeader?: string;
  subTextHeader?: string;
  onClickFilter?: () => void;
  handleOpenModal?: () => void;
  renderIconRight?: React.ReactNode;
  isShowRetryButton?: boolean;
  isRetryLoading?: boolean;
  onRetry?: () => void;
  isShowTooltip?: boolean;
  bgWhite?: boolean;
  bgLightGray?: boolean;
  anotherContent?: React.ReactNode;
  isPublicGroupChat?: boolean;
}

function HeaderMember(props: HeaderMemberProps) {
  const {
    isFixedTop,
    isHeaderMain,
    isLowercase,
    disableIcLeft,
    txtLeft,
    isChangeTxtHeader,
    icRight,
    customStyles = {},
    txtRight,
    onClickRightIcon,
    isError,
    isMobile,
    classContainer = '',
    textHeaderClassName,
    isHeaderTextNone,
    customClassHeader = '',
    renderIconLeft = undefined,
    registerRefWithKeyAuto,
    icLeft,
    onClickLeftIcon,
    renderHeader,
    textHeader,
    subTextHeader,
    onClickFilter,
    handleOpenModal,
    renderIconRight,
    isShowRetryButton = false,
    isRetryLoading = false,
    onRetry = () => {},
    isShowTooltip = false,
    bgWhite,
    anotherContent,
    isPublicGroupChat = false,
    bgLightGray = false,
  } = props;
  const { isDarkMode: darkMode } = useTheme();

  const _icLeft = icLeft || (darkMode ? icBackHeaderWhite : icBackHeader);
  const [isOpenTooltip, showTooltip] = useState(false);
  const customHeaderWrapper = cn('header-member-mobile-wrapper', {
    'fixed-top': isFixedTop,
  });
  const customHeaderContainer = cn({
    'header-content-mobile': isMobile,
    'header-content': !isMobile,
    'background-light-gray': bgLightGray,
    'background-white': bgWhite && !darkMode,
    [classContainer]: classContainer,
  });
  const customTextHeader = cn('__center-wrapper', textHeaderClassName, {
    'text-main': isHeaderMain,
    'text-transform-lowercase': isLowercase,
    'text-transform-none': isHeaderTextNone,
    [customClassHeader]: customClassHeader,
  });
  let timeoutHiddenTooltip: NodeJS.Timeout | null = null;

  useEffect(() => {
    showTooltip(isShowTooltip);
    if (isShowTooltip) {
      if (timeoutHiddenTooltip) {
        clearTimeout(timeoutHiddenTooltip);
        timeoutHiddenTooltip = null;
      }

      timeoutHiddenTooltip = setTimeout(() => {
        showTooltip(false);
      }, 5000);
    }
  }, [isShowTooltip]);

  return (
    <div
      className={customHeaderWrapper}
      ref={registerRefWithKeyAuto ? (elm: any) => registerRefWithKeyAuto(elm, REF_ID.HEADER_MEMBER_WRAPPER) : null}
      style={customStyles}>
      <div className={customHeaderContainer}>
        {renderIconLeft || (
          <div className="__left-wrapper" onClick={(_icLeft && !disableIcLeft) || txtLeft !== '' ? onClickLeftIcon : () => {}}>
            {_icLeft && !disableIcLeft && <IconButton icSrc={_icLeft} />}
            {txtLeft !== '' && <span>{txtLeft}</span>}
          </div>
        )}
        {renderHeader ||
          (textHeader && !isChangeTxtHeader && (
            <div className={customTextHeader}>
              <span className="heading" dangerouslySetInnerHTML={createMarkup(textHeader)}></span>
              {subTextHeader && (
                <div className="__sub-text-heading" onClick={onClickFilter}>
                  {subTextHeader}
                  <IconButton icSrc={icArrDownEvt} />
                </div>
              )}
            </div>
          ))}
        {isChangeTxtHeader && (
          <div className={customTextHeader} onClick={handleOpenModal}>
            <span>{textHeader}</span>
            <Img src={icArrow} alt="icon-arrow" />
          </div>
        )}
        {renderIconRight || (
          <div className="__right-wrapper" onClick={icRight || txtRight !== '' ? onClickRightIcon : () => {}}>
            {icRight && <IconButton icSrc={icRight} />}
            {icRight && (
              <ProfileOptionDropDown
                isTooltip
                messageTooltip={I18n.t('MemberSearchScreen.SearchFiltersOn')}
                className={isOpenTooltip ? 'header-tooltip-filter show' : 'hidden'}
              />
            )}
            {txtRight !== '' && <span>{txtRight}</span>}
          </div>
        )}
      </div>
      {isError && (
        <ReconnectingLabel
          isShowRetryButton={isShowRetryButton}
          isRetryLoading={isRetryLoading}
          tryReconnect={onRetry}
          publicGroupChat={isPublicGroupChat}
        />
      )}
      {anotherContent}
    </div>
  );
}

export default HeaderMember;
